(() => {
  if (window.matchMedia("(pointer: coarse)").matches) return;

  const cursor = document.querySelector(".az-cursor");
  if (!cursor) return;

  let x = window.innerWidth / 2;
  let y = window.innerHeight / 2;

  const dot = cursor.querySelector(".az-cursor__dot");
  const ring = cursor.querySelector(".az-cursor__ring");
  const label = cursor.querySelector(".az-cursor__label");

  const lerp = (a,b,n)=> (1-n)*a + n*b;
  let fx=x, fy=y;

  const loop = () => {
    fx = lerp(fx, x, 0.18);
    fy = lerp(fy, y, 0.18);
    cursor.style.transform = `translate3d(${fx}px, ${fy}px, 0)`;
    requestAnimationFrame(loop);
  };
  requestAnimationFrame(loop);

  window.addEventListener("mousemove", (e) => {
    x = e.clientX;
    y = e.clientY;
  }, { passive: true });

  const enter = (text="VER") => {
    label.textContent = text;
    ring.classList.add("is-big");
    dot.classList.add("is-hidden");
    label.classList.add("is-visible");
  };

  const leave = () => {
    ring.classList.remove("is-big");
    dot.classList.remove("is-hidden");
    label.classList.remove("is-visible");
  };

  const selector = 'a, button, [role="button"], input[type="submit"], .btn, .button, .shopify-payment-button__button';
  document.querySelectorAll(selector).forEach((el) => {
    el.addEventListener("mouseenter", () => enter(el.getAttribute("data-az-label") || "VER"));
    el.addEventListener("mouseleave", leave);
  });
})();